<tr>
  <slot />
</tr>

<style>
  tr:nth-child(odd) {
    background-color: #f2f2f2;
  }

  tr:nth-child(even) {
    background-color: white;
  }
</style>